import "./App.css";
import { useEffect, useContext } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";

import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Landing from "./pages/Landing";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Forgot from "./pages/Forgot";
import EmailVerify from "./pages/EmailVerify";
import Header from "./pages/Header";
import BotTradeHistory from "./pages/BotTradeHistory";
import TfaLogin from "./pages/TfaLogin";
import TermsCondition from "./pages/TermsCondition";
import Home from "./pages/Home";
import Assets from "./pages/Assets";
// import { createWeb3Modal, defaulztConfig } from "@web3modal/ethers/react";
import Strategies from "./pages/Strategies";
import Refferal from "./pages/Refferal";
import Profile from "./pages/Profile";
import Deposit from "./pages/Deposit";
import Withdraw from "./pages/Withdraw";
import ApiBind from "./pages/ApiBind";
import AutoLogout from "./AutoLogout";
import Team from "./pages/Team";
import Security from "./pages/Security";
import SecurityWithdraw from "./pages/SecurityWithdraw";
import SecurityLoginpass from "./pages/SecurityLoginpass";
import SecurityTfa from "./pages/SecurityTfa";
import Policy from "./pages/Policy";
import FAQ from "./pages/FAQ";
import PrivateRoute from "./pages/PrivateRoute";
import { UserProvider } from "./contexts/UserContext";
import { TfaProvider } from "./contexts/2facontext";
import Upgrade from "./pages/Upgrade";
import UpgradePad from "./pages/UpgradePad";
import transitions from "@material-ui/core/styles/transitions";
import PageNotFound from "./pages/PageNotFound";
import UnderMaintanence from "./pages/UnderMaintanence";
import WithdrawHistory from "./pages/withdrawhistory";
import Deposithistory from "./pages/deposithistory";
import LoginHistory from "./pages/loginHistory";
import AllHistory from "./pages/allhistory";
import Privacypolicy from "./pages/Privacypolicy";
import Support from "./pages/Support";
import HistoryAll from "./pages/HistoryAll";
import SupportHistory from "./pages/supporthistory";
import WalletTransfer from "./pages/WalletTransfer";
import Referralhistory from "./pages/refferalhistory";
import TeamHistory from "./pages/teamhistory";
import PoolMetrics from "./pages/PoolMetrics";
import BalanceHistory from "./pages/BalanceHistory";
import DepositNew from "./pages/DepositNew";
import Checkout from "./pages/Checkout";

import i18n from "./translate/i18n";
// import './translate/i18n';

import "@rainbow-me/rainbowkit/styles.css";
import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import { getDefaultConfig, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import {
  metaMaskWallet,
  rabbyWallet,
  safepalWallet,
  trustWallet,
  rainbowWallet,
  walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { WagmiProvider } from "wagmi";
import { mainnet, polygon, optimism, arbitrum, base } from "wagmi/chains";
import Disclaimer from "./pages/Disclaimer";
import UserGuide from "./pages/UserGuide";
import Affiliate from "./pages/Affiliate";
import FuelWallet from "./pages/FuelWallet";
import Tradebot from "./pages/Tradebot";
import LandingNew from "./pages/LandingNew";
// import LandingNew1 from "./pages/LandingNew1";
import Aboutus from "./pages/Aboutus";
import FAQNew from "./pages/FAQNew";
import Contact from "./pages/Contact";
import Guides from "./pages/Guides";
import AffiliateTerms from "./pages/AffiliateTerms";
import TermsOfService from "./pages/TermsOfService";
import Strategy from "./pages/Strategy";
import BinargeAcademy from "./pages/BinargeAcademy";
import APIKey from "./pages/APIKey";
import Moonpay from "./pages/Moonpay";
// import { MoonPayProvider } from '@moonpay/moonpay-react';
import Paddlecheckout from "./pages/Paddlecheckout";

import Deposit_buycrypto from "./pages/Deposit_buycrypto";

const queryClient = new QueryClient();

const detectInstalledWallets = () => {
  const installedWallets = [];

  if (typeof window !== "undefined" && window.ethereum) {
    const providers = window.ethereum.providers || [window.ethereum];

    providers.forEach((provider) => {
      if (provider.isMetaMask) installedWallets.push(metaMaskWallet);
      if (provider.isRabby) installedWallets.push(rabbyWallet);
      if (provider.isSafePal) installedWallets.push(safepalWallet);
      if (provider.isTrust) installedWallets.push(trustWallet);
      if (provider.isRainbow) installedWallets.push(rainbowWallet);
    });
  }

  return installedWallets;
};

const installedWallets = detectInstalledWallets();

const walletGroups = [
  ...(installedWallets.length > 0
    ? [
        {
          groupName: "Installed",
          wallets: installedWallets,
        },
      ]
    : []),
  {
    groupName: "Recommended",
    wallets: [
      metaMaskWallet,
      rabbyWallet,
      safepalWallet,
      trustWallet,
      rainbowWallet,
      walletConnectWallet,
    ],
  },
];

const connectors = connectorsForWallets(walletGroups, {
  appName: "RainbowKit App",
  projectId: "0b8444fa79de9a3821c5410564de263f",
});

const config = getDefaultConfig({
  appName: "My RainbowKit App",
  projectId: "0b8444fa79de9a3821c5410564de263f",
  chains: [mainnet, polygon, optimism, arbitrum, base],
  ssr: true,
  connectors,
});

function App() {
  // const navigate = useNavigate();
  // const location = useLocation();

  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
      });
    }
  }, []);

  useEffect(() => {
    let str = window.location.href;
    if (!str.toLowerCase().includes("verification")) {
      sessionStorage.setItem("timerstatus", "false");
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = i18n.language; // Update lang attribute
    // console.log(i18n.language);
  }, [i18n.language]);

  return (
    <UserProvider>
      <TfaProvider>
        <WagmiProvider config={config}>
          <QueryClientProvider client={queryClient}>
            <RainbowKitProvider>
              {/* <MoonPayProvider
            apiKey="pk_test_e53xR1W4ULDxZNnunsXpi5jLlMDxyvt1"
            debug> */}

              <BrowserRouter>
                {/* <Header /> */}
                <AutoLogout />
                <ToastContainer
                  autoClose={2500}
                  transition={Slide}
                  hideProgressBar={true}
                />
                <Routes>
                  {/* <Route path="/" element={<Landing />} /> */}
                  <Route path="/:lang?" element={<LandingNew />} />
                  {/* <Route path="/termscondition" element={<TermsCondition />} /> */}
                  <Route
                    path="/terms-of-service"
                    element={<TermsOfService />}
                  />
                  <Route
                    path="/terms-of-service/:lang"
                    element={<TermsOfService />}
                  />
                  <Route
                    path="/privacy-cookies-policy"
                    element={<Privacypolicy />}
                  />
                    <Route
                    path="/privacy-cookies-policy/:lang"
                    element={<Privacypolicy />}
                  />
                  <Route path="/disclaimer" element={<Disclaimer />} />
                  <Route path="/disclaimer/:lang" element={<Disclaimer />} />
                  <Route path="/user-guide" element={<UserGuide />} />
                  <Route path="/user-guide/:lang" element={<UserGuide />} />
                  <Route path="/affiliate" element={<Affiliate />} />
                  <Route path="/affiliate/:lang" element={<Affiliate />} />
                  <Route path="/affiliate-terms" element={<AffiliateTerms />} />
                  <Route
                    path="/affiliate-terms/:lang"
                    element={<AffiliateTerms />}
                  />
                  <Route path="/fuel-wallet" element={<FuelWallet />} />
                  <Route path="/fuel-wallet/:lang" element={<FuelWallet />} />
                  <Route path="/tradebot" element={<Tradebot />} />
                  <Route path="/tradebot/:lang" element={<Tradebot />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/register/:lang" element={<Register />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/login/:lang" element={<Login />} />
                  <Route path="/forgot" element={<Forgot />} />
                  <Route path="/forgot/:lang" element={<Forgot />} />
                  <Route path="/verification" element={<EmailVerify />} />
                  <Route path="/verification/:lang" element={<EmailVerify />} />
                  <Route path="/tfa" element={<TfaLogin />} />
                  <Route path="/tfa/:lang" element={<TfaLogin />} />
                  <Route path="/*" element={<PageNotFound />} />
                  <Route path="/maintanence" element={<UnderMaintanence />} />
                  <Route
                    path="/maintanence/:lang"
                    element={<UnderMaintanence />}
                  />

                  {/* Protected Routes */}
                  <Route
                    path="/home"
                    element={
                      <PrivateRoute>
                        <Home />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/home/:lang"
                    element={
                      <PrivateRoute>
                        <Home />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/assets"
                    element={
                      <PrivateRoute>
                        <Assets />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/assets/:lang"
                    element={
                      <PrivateRoute>
                        <Assets />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/strategies"
                    element={
                      <PrivateRoute>
                        <Strategies />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/strategies/:lang"
                    element={
                      <PrivateRoute>
                        <Strategies />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/loginHistory"
                    element={
                      <PrivateRoute>
                        <LoginHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/loginHistory/:lang"
                    element={
                      <PrivateRoute>
                        <LoginHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/referral"
                    element={
                      <PrivateRoute>
                        <Refferal />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/referral/:lang"
                    element={
                      <PrivateRoute>
                        <Refferal />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/supporthistory"
                    element={
                      <PrivateRoute>
                        <SupportHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/supporthistory/:lang"
                    element={
                      <PrivateRoute>
                        <SupportHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/allhistory"
                    element={
                      <PrivateRoute>
                        <AllHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/allhistory/:lang"
                    element={
                      <PrivateRoute>
                        <AllHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/transferwallet"
                    element={
                      <PrivateRoute>
                        <WalletTransfer />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/transferwallet/:lang"
                    element={
                      <PrivateRoute>
                        <WalletTransfer />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/withdrawhistory"
                    element={
                      <PrivateRoute>
                        <WithdrawHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/withdrawhistory/:lang"
                    element={
                      <PrivateRoute>
                        <WithdrawHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/deposithistory"
                    element={
                      <PrivateRoute>
                        <Deposithistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/deposithistory/:lang"
                    element={
                      <PrivateRoute>
                        <Deposithistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/profile/:lang"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/deposit"
                    element={
                      <PrivateRoute>
                        <DepositNew />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/deposit/:lang"
                    element={
                      <PrivateRoute>
                        <DepositNew />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/withdraw"
                    element={
                      <PrivateRoute>
                        <Withdraw />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/withdraw/:lang"
                    element={
                      <PrivateRoute>
                        <Withdraw />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/apibind"
                    element={
                      <PrivateRoute>
                        <ApiBind />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/apibind/:lang"
                    element={
                      <PrivateRoute>
                        <ApiBind />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/upgrade"
                    element={
                      <PrivateRoute>
                        <Upgrade />
                        {/* <UpgradePad/> */}
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/upgrade/:lang"
                    element={
                      <PrivateRoute>
                        <Upgrade />
                        {/* <UpgradePad/> */}
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/upgradepad"
                    element={
                      <PrivateRoute>
                        <UpgradePad />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/upgradepad/:lang"
                    element={
                      <PrivateRoute>
                        <UpgradePad />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/upgrade/:id"
                    element={
                      <PrivateRoute>
                        {/* <Upgrade /> */}
                         <UpgradePad/>
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/upgrade/:id/:lang"
                    element={
                      <PrivateRoute>
                        {/* <Upgrade /> */}
                         <UpgradePad/>
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/bottradehistory"
                    element={
                      <PrivateRoute>
                        <BotTradeHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/bottradehistory/:lang"
                    element={
                      <PrivateRoute>
                        <BotTradeHistory />
                      </PrivateRoute>
                    }
                  />
                  {/* <Route
                    path="/team"
                    element={
                      <PrivateRoute>
                        <Team />
                      </PrivateRoute>
                    }
                  /> */}
                  <Route
                    path="/security"
                    element={
                      <PrivateRoute>
                        <Security />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/security/:lang"
                    element={
                      <PrivateRoute>
                        <Security />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/security-withdraw"
                    element={
                      <PrivateRoute>
                        <SecurityWithdraw />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/security-withdraw/:lang"
                    element={
                      <PrivateRoute>
                        <SecurityWithdraw />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/security-loginpassword"
                    element={
                      <PrivateRoute>
                        <SecurityLoginpass />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/security-loginpassword/:lang"
                    element={
                      <PrivateRoute>
                        <SecurityLoginpass />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/security-tfa"
                    element={
                      <PrivateRoute>
                        <SecurityTfa />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/security-tfa/:lang"
                    element={
                      <PrivateRoute>
                        <SecurityTfa />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/support"
                    element={
                      <PrivateRoute>
                        <Support />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/support/:lang"
                    element={
                      <PrivateRoute>
                        <Support />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/referralhistory"
                    element={
                      <PrivateRoute>
                        <Referralhistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/referralhistory/:lang"
                    element={
                      <PrivateRoute>
                        <Referralhistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/history"
                    element={
                      <PrivateRoute>
                        <HistoryAll />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/history/:lang"
                    element={
                      <PrivateRoute>
                        <HistoryAll />
                      </PrivateRoute>
                    }
                  />

                  {/* <Route
                    path="/teamhistory"
                    element={
                      <PrivateRoute>
                        <TeamHistory />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/poolhistory"
                    element={
                      <PrivateRoute>
                        <PoolMetrics />
                      </PrivateRoute>
                    }
                  /> */}

                  <Route
                    path="/balance-history"
                    element={
                      <PrivateRoute>
                        <BalanceHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/balance-history/:lang"
                    element={
                      <PrivateRoute>
                        <BalanceHistory />
                      </PrivateRoute>
                    }
                  />

                  {/* Public Routes */}
                  <Route path="/policy" element={<Policy />} />
                  <Route path="/policy/:lang" element={<Policy />} />
                  {/* <Route path="/faq" element={<FAQ />} /> */}
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/checkout/:lang" element={<Checkout />} />
                  <Route path="/about-us" element={<Aboutus />} />
                  <Route path="/about-us/:lang" element={<Aboutus />} />
                  <Route path="/faq" element={<FAQNew />} />
                  <Route path="/faq/:lang" element={<FAQNew />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/contact/:lang" element={<Contact />} />
                  <Route path="/guides-tutorials" element={<Guides />} />
                  <Route path="/guides-tutorials/:lang" element={<Guides />} />
                  <Route path="/api-key" element={<APIKey />} />
                  <Route path="/api-key/:lang" element={<APIKey />} />
                  <Route path="/binarge-academy" element={<BinargeAcademy />} />
                  <Route
                    path="/binarge-academy/:lang"
                    element={<BinargeAcademy />}
                  />
                  <Route path="/strategy" element={<Strategy />} />
                  <Route path="/strategy/:lang" element={<Strategy />} />
                  <Route path="/moonpay" element={<Moonpay />} />
                  <Route path="/moonpay/:lang" element={<Moonpay />} />
                  <Route path="/paddle_checkout" element={<Paddlecheckout />} />
                  <Route
                    path="/paddle_checkout/:lang"
                    element={<Paddlecheckout />}
                  />

                  <Route
                    path="/buycrypto"
                    element={
                      <PrivateRoute>
                        <Deposit_buycrypto />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/buycrypto/:lang"
                    element={
                      <PrivateRoute>
                        <Deposit_buycrypto />
                      </PrivateRoute>
                    }
                  />

                </Routes>
              </BrowserRouter>
              {/* </MoonPayProvider> */}
            </RainbowKitProvider>
          </QueryClientProvider>
        </WagmiProvider>
      </TfaProvider>
    </UserProvider>
  );
}

export default App;
